import {createGUID,timeQuantum} from '@/utils/tools'
import {
    chunk,
    cancel,
    merge
} from "@/api/upload";


const _modules=[
    "LifeVideo",
    "TutorAudio",
    "LifePhoto",
    "UserFace",
    "CoursewareResources",
    "TutorCertificates",
    "Absent",
    "IdentityImg",
    "BankStatement",
    "ElectronicallySigned",
    "ProblemScreenshot",
    "Attachment",
    "AppealFile",
    "LeaveReason",
    "TeacherCertification",
    "PoliceCertificate",
    "TesolCertificateSelf",
    "ProfessionalIdPhoto",
    "GroupPhoto",
    "ToturTaskFile",
    "SubjectWrong",
]

var _uploader=function(opt){

    let _option=Object.assign({
        chunkSize: 0.5*1024*1024,
        module:'',
        progressbar:null,
        alert:alert
    },opt)
    
    let _moduleName= _option.module
    if(_modules.indexOf(_moduleName)==-1){
        throw new Error(`上传模块[${_moduleName}]不存在`)
    }
    if(!_option.progressbar){
        throw new Error('progressbar 未注册')
    }

    _option.progressbar.registerEvent(async ()=>{
        _file = null
        _currentChunk = 0
        await cancel(_fileCode,_moduleName)
        console.log('upload cancel...')
    })

    let _currentChunk,_totalChunk,_file,_fileCode,_chunkUploadTime,_remainingTime
        ,_chunked =0
        ,_totalChunkSize= 0
        ,_mergeShow= true
    
    //展示上传生活视频的进度
    let _display = completed => {

        if(!completed){
            completed = Math.floor(
                _chunked / _totalChunkSize  * 100
            );
        }
        if (completed == 0) {
            completed = 1;
        }else if(completed > 100){
            completed= 100
        }
        
        console.log(`completed....${completed}%`)

        _option.progressbar.open(completed,_remainingTime)
    }

    let _fileMerge = async ()=> {

        console.log('merge....')

        if(_mergeShow) _display(99)

        let formdata = new FormData();
        formdata.append("fileCode", _fileCode);
        formdata.append("moduleName",_moduleName);

        let res= await merge(formdata)
        let resultObj = res.data;
        if (resultObj.ErrorCode === 0) {
            if(_mergeShow) _display(100)
            resultObj.Body.FileName = _file.name
        }
        return resultObj
    }
    let _chunkUpload= async () =>{

        if(!_file) {
            _error()
            return {
                ErrorCode: 100,
                Msg: "Please select a file first."
            }
        }

        //保存分块

        _display()

        let chunkFile = _file.slice(
            _currentChunk * _option.chunkSize,
            (_currentChunk + 1) * _option.chunkSize
        );

        if(!chunkFile){
            _error()
            return {
                ErrorCode: 100,
                Msg: "Upload failed, please try again later."
            }
        }
       
        _chunked+= _file.size< _option.chunkSize?_file.size: _option.chunkSize

        let lastTime=new Date()

        var renameFile =new File([chunkFile], _file.name,{type:_file.type});

        let formdata = new FormData();
        formdata.append("file" , renameFile); //
        formdata.append("chunk", _currentChunk + 1); //分块序号
        formdata.append("fileCode", _fileCode);
        formdata.append("fileName", _file.name);
        formdata.append("moduleName", _moduleName);

        let res= await chunk(formdata)

        _setChunkTime(lastTime)

        let resultObj = res.data;
        if (resultObj.ErrorCode === 0) {
            _currentChunk++;
            if (_currentChunk < _totalChunk) {
                return await _chunkUpload();
            } else {
                return await _fileMerge();
            }
        } else {
            return resultObj
        }
    }
    let _error = () =>{
        _option.progressbar.cancel()
    }
    let _setChunkTime= lastTime=>{
        _chunkUploadTime = timeQuantum(lastTime)
        _remainingTime = _chunkUploadTime*(_totalChunk-_currentChunk)
    }
    let _upload= async file=> {
        _init(file)
        _chunked= 0
        _mergeShow= true
        _totalChunkSize= file.size
        var result = await _chunkUpload()
        if(result.ErrorCode!=0){
            _error()
        }
        return result
    }
    let _uploadBatch= async files=> {
        var datas=[]
        _mergeShow= false

        for(var i=0;i<files.length;i++){
            _totalChunkSize+=files[i].size
        }
        for(var i=0;i<files.length;i++){
            if(i===files.length-1){
                _mergeShow= true
            }
            var data = await _upload(files[i])
            if(!data || data.ErrorCode!=0){
                return data
            }

            datas.push(data)
        }
        return {
            ErrorCode: 0,
            Body: datas
        }
    }
    let _uploadBatchWithKey = async filesData => {

        if(filesData instanceof FileList){
            filesData=[{
                key: "DEFAULTKEY",
                data: filesData
            }]
        }else if(filesData instanceof Array){
            filesData= filesData.map(t=>{
                if(t.file instanceof FileList || t.file instanceof Array){
                    var _files=[]
                    for(var i=0;i<t.file.length;i++){
                        _files.push({
                            key: t.key,
                            file: t.file[i]
                        })
                    }
                    return _files;
                }else{
                    return [t]
                }
            }).reduce((prev,next)=>{
                return prev.concat(next)
            })
        }

        var datas={}
        _mergeShow= false
        for(var i=0;i<filesData.length;i++){
            _totalChunkSize+=filesData[i].file.size
        }
        for(var i=0;i<filesData.length;i++){
            _init(filesData[i].file)

            if(filesData[i].module){
                _moduleName = filesData[i].module
            }

            if(i===filesData.length-1){
                _mergeShow= true
            }

            var data = await _chunkUpload()
            if(!data || data.ErrorCode!=0){
                _error()
                return data
            }
            datas[filesData[i].key]=datas[filesData[i].key]||[]
            datas[filesData[i].key].push(data.Body)
        }
        return {
            ErrorCode: 0,
            Body: datas
        }
    }
    let _init= file=>{
        _file= file
        _currentChunk= 0
        _totalChunk= 1
        _fileCode = createGUID()
        _chunkUploadTime= 0
        _remainingTime= 5*60
        _totalChunk = Math.ceil(
            _file.size / _option.chunkSize
        );
    }
    return {
        upload:_upload,
        uploadBatch:_uploadBatch,
        uploadBatchWithKey :_uploadBatchWithKey,
    }
}
export function uploader(opt){
    return _uploader(opt)
}